export const MY_PROFILE_DETAILS_REQUEST = 'MY_PROFILE_DETAILS_REQUEST';
export const MY_PROFILE_DETAILS_RESPONSE = 'MY_PROFILE_DETAILS_RESPONSE';

export const SETUP_PROFILE_REQUEST = 'SETUP_PROFILE_REQUEST';
export const SETUP_PROFILE_RESPONSE = 'SETUP_PROFILE_RESPONSE';
